class Monitoring.Models.Label extends Backbone.Model
  urlRoot: '/monitoring/labels'

  initialize: ->
    children = _.map(@get('children'), (child) -> new Monitoring.Models.Label(child))
    @set({
      children: new Monitoring.Collections.LabelsCollection(children),
      keywords: new Monitoring.Collections.KeywordsCollection(@get('keywords'))
    })

  parse: (response) ->
    if response.keywords
      response.keywords = new Monitoring.Collections.KeywordsCollection(response.keywords)
    return response

  toJSON: ->
    json = super()
    children = []
    json.children.each((child) ->
      children.push(child.toJSON())
    )
    json.children = children
    return json

  findKeyword: (id) ->
    keywords = @get('keywords').where({id: id})
    return keywords[0] if keywords.length > 0



class Monitoring.Collections.LabelsCollection extends Backbone.Collection
  model: Monitoring.Models.Label
  url: '/monitoring/labels.json'

  initialize: ->
    @deleted = []

  get: (obj) ->
    id = obj.id || obj.cid || obj[this._idAttr] || obj
    result = null
    @eachLabel((label) ->
      if label.id == id
        result = label
    )
    return result

  remove: (object, deleteInServer, options) ->
    @deleted.push(object) if deleteInServer and @deleted.indexOf(object) == -1

    if @contains(object)
        super(object, options)
    else
      @each((label) ->
        label.get('children').remove(object, deleteInServer, options)
      )
      @trigger('remove')


  addAsChild: (label, parent_id) ->
    parent = @get(parent_id)
    parent.get('children').add(label)
    @trigger('add', label)

  comparator: (label) ->
    return label.get('name').toLowerCase()

  eachLabel: (callback) ->
    @each((label, index) =>
      callback.call(@, label, index)
      label.get('children').eachLabel(callback)
    )

  eachKeyword: (callback) ->
    @eachLabel((label, label_index) ->
      label.get('keywords').each((keyword, kw_index) ->
        callback.call(label, keyword, label_index, kw_index)
      )
    )

  getKeywords: ->
    result = []
    @eachLabel((label) ->
      result = _.union(result, _.map(label.get('keywords').models, (model) -> { name: model.get('name'), id: model.get('id') }))
    )
    return result

  findKeywordsByName: (name) ->
    result = []
    @eachKeyword((keywords) ->
      if keyword.get('name') == name
        result.push(keyword)
    )
    return result


  toTreeJSON: ->
    data = []
    @each((label) =>

      children = label.get('children').toTreeJSON()
      keywords = []
      label.get('keywords').each((keyword) =>
          keywords.push(
            data:
              title: keyword.get('name')
              icon: 'keyword'
            attr:
              rel: 'keyword'
              id: 'keyword_' + keyword.get('id')
          )
      )

      data.push(
        data:
          title: label.get('name')
          icon: 'label'
        attr:
          rel: 'label'
          id: 'label_' + label.get('id')
        children: keywords.concat(children)
        state: 'open'
      )
    )
    return data
